const SectionHeader = ({ title, description, align = "left", testId }) => {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";

  return (
    <div className={`max-w-3xl space-y-3 ${alignment}`} data-testid={testId}>
      <h2
        className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl"
        data-testid={`${testId}-title`}
      >
        {title}
      </h2>
      <p
        className="text-base leading-relaxed text-slate-600 md:text-lg"
        data-testid={`${testId}-description`}
      >
        {description}
      </p>
    </div>
  );
};

export default SectionHeader;